/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleState } from './moduleState';

export type ModuleCreateRequestState = ModuleState | null;
